import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { OtherTiles, ResultsTiles } from './tiles';
import Pagination from './pagination';
import { Helmet } from 'react-helmet';
import usePagination from '../../../hooks/use-pagination';
import { isValidArray } from '../../../components/utilities/validations';
import { getCookie } from '../../../components/utilities/functions';

const PLPResults = ({ tiles, hideEncompass, seo, staticTiles, dynamicPageState, isEastCoast, pageLoading, highlightItems, quickShipItems, tileSort, otherTiles, inlinePromos, isLogged }) => {
	const [currentTiles, setCurrentTiles] = useState(tiles);

	const isLargeScreen = useMediaQuery({ query: '(min-width: 1024px)' });
	const isMediumScreen = useMediaQuery({ query: '(min-width: 550px)' });
	const calcTilesPerPage = () => {
		if (isLargeScreen) return 15;
		if (isMediumScreen) return 12;
		return 8;
	};
	const tilesPerPage = calcTilesPerPage();

	useEffect(() => {
		if (hideEncompass && isValidArray(tiles)) {
			const hasEncompass = tiles.some((tile) => tile.backend_name.includes('encompass'));
			if (hasEncompass) {
				setCurrentTiles(tiles.filter((tile) => !tile.backend_name.includes('encompass')));
			}
		}

		if (isValidArray(inlinePromos)) {
			const proCookie = getCookie('CustomerType') === 'Professional';
			const inlinePromo = !isLogged && proCookie ? inlinePromos.find((promo) => promo?.type === 'pro') : inlinePromos.find((promo) => promo?.type === 'quiz');

			if (!inlinePromo) return;

			setCurrentTiles((prevTiles) => {
				const filteredTiles = prevTiles.filter((tile) => tile.type !== inlinePromo.type);
				const newTiles = [...filteredTiles];
				newTiles.splice(3, 0, inlinePromo);

				return newTiles;
			});
		}
	}, [tiles, hideEncompass, inlinePromos, isLargeScreen, isMediumScreen, isLogged]); //isLargeScreen, isMediumScreen, required otherwise inlinePromo will disappear on resize, to investigated when doing ECV-9403

	const { pageCount, title, isLastPage } = usePagination({
		tiles: tiles,
		tilesPerPage: tilesPerPage,
		seoTitle: seo.title,
	});

	const hasOtherTiles = isValidArray(otherTiles?.dynamic) && otherTiles.dynamic[0]?.card_type === 'tile';

	return (
		<>
			<ResultsTiles
				currentTiles={currentTiles}
				staticTiles={staticTiles}
				dynamicPageState={dynamicPageState}
				isEastCoast={isEastCoast}
			/>

			{hasOtherTiles && isLastPage && <OtherTiles otherTiles={otherTiles} />}
			{/* isLastPage ultimately always ends up false due to re-renders, to be resolved in ECV-9403 */}

			{!pageLoading && dynamicPageState && tiles && (
				<>
					<Helmet>
						<title>{title}</title>
					</Helmet>

					<Pagination
						tiles={tiles}
						tilesPerPage={tilesPerPage}
						highlightItems={highlightItems}
						quickShipItems={quickShipItems}
						currentTiles={[currentTiles, setCurrentTiles]}
						tileSort={tileSort || 'recommended'}
						isEastCoast={isEastCoast}
						seo={seo}
					/>
				</>
			)}
		</>
	);
};

PLPResults.propTypes = {
	staticTiles: PropTypes.array,
	tiles: PropTypes.array,
	otherTiles: PropTypes.object,
	highlightItems: PropTypes.array,
	quickShipItems: PropTypes.array,
	dynamicPageState: PropTypes.bool,
	pageLoading: PropTypes.bool,
	tileSort: PropTypes.string,
	isEastCoast: PropTypes.bool,
	hideEncompass: PropTypes.bool,
	seo: PropTypes.object,
	inlinePromos: PropTypes.array,
	isLogged: PropTypes.bool,
};

export default PLPResults;
